/**
 * Widget-internal language VARIANTS: copy overlays that are not languages of their own.
 *
 * - `en-soc`: sweepstakes English (bet → play, payout → prize).
 * - `es-lotobola`: Lotobola's (EHLTech) Spanish — their own game names on top of `es`.
 *
 * A variant falls back to its base language in i18next (blank or missing keys resolve to the base), is hidden from
 * the language picker (`EXCLUDED_LANGUAGES`), and must never reach `Intl` as-is (see `safeLocale`).
 */
export const LANGUAGE_VARIANT_BASE: Record<string, string> = {
  'en-soc': 'en',
  'es-lotobola': 'es'
}

/** Variants that hide currency symbols (sweepstakes coins are not money). */
export const SWEEPSTAKES_LANGUAGES = ['en-soc']

/** The real language behind a variant; any other language is returned as-is. */
export const baseLanguage = (language: string): string =>
  LANGUAGE_VARIANT_BASE[language] ?? language

/** Variants that play no voice-overs (they are recorded in English only). */
export const NO_VOICEOVER_LANGUAGES = ['es-lotobola']

/**
 * Whether the phase voice-overs play. They are recorded in English only: Lotobola's variant plays none (owner's
 * call, 2026-10-20); every other language, Spanish included, keeps the English fallback.
 */
export const playsVoiceOver = (language: string): boolean =>
  !NO_VOICEOVER_LANGUAGES.includes(language)
